/**
 * Nhãn nhận diện cho từng nhóm mẫu Excel: một icon và một màu riêng.
 *
 * Vẽ bằng SVG ngay trong mã, không dùng file ảnh: luôn nét trên mọi màn hình,
 * không thêm lượt tải, và không làm trang /mau dài thêm.
 * Màu chỉ để phân biệt nhanh — thông tin thật vẫn nằm ở tiêu đề và mô tả nhóm.
 */
export const MAU_NHOM = {
  dashboard: '#a65e16',
  'mo-hinh-tai-chinh': '#0B7A75',
  'bao-cao-tai-chinh': '#1E5F9E',
  'dinh-gia': '#A65E16',
  'co-phan': '#5B4B8A',
  'chi-so-hoat-dong': '#2F6B4F',
  'due-diligence': '#123B5D',
  'quan-ly-goi-von': '#B0561C',
};

export const mauCuaNhom = (slug) => MAU_NHOM[slug] || '#123B5D';

const HINH = {
  // Bảng có ô số và cột: dashboard.
  dashboard: <><rect x="3" y="3" width="18" height="18" rx="2.5" fill="none" strokeWidth="1.8" /><path d="M3 9h18" fill="none" strokeWidth="1.8" /><rect x="6.5" y="14" width="2.6" height="4" rx="0.6" /><rect x="10.7" y="12" width="2.6" height="6" rx="0.6" /><rect x="14.9" y="11" width="2.6" height="7" rx="0.6" /></>,
  // Biểu đồ cột tăng dần — dự phóng doanh thu, chi phí.
  'mo-hinh-tai-chinh': <><rect x="3" y="14" width="4" height="7" rx="1" /><rect x="10" y="9" width="4" height="12" rx="1" /><rect x="17" y="4" width="4" height="17" rx="1" /></>,
  // Tờ báo cáo có dòng chữ.
  'bao-cao-tai-chinh': <><rect x="4" y="3" width="16" height="18" rx="2" fill="none" strokeWidth="1.8" /><path d="M8 8h8M8 12h8M8 16h5" fill="none" strokeWidth="1.8" strokeLinecap="round" /></>,
  // Thẻ giá.
  'dinh-gia': <><path d="M3 11.5V4.5A1.5 1.5 0 0 1 4.5 3h7l9 9-8 8-9.5-8.5Z" fill="none" strokeWidth="1.8" strokeLinejoin="round" /><circle cx="7.5" cy="7.5" r="1.6" /></>,
  // Biểu đồ tròn — tỷ lệ sở hữu.
  'co-phan': <><path d="M12 3a9 9 0 1 0 9 9h-9V3Z" /><path d="M14 2.2A9 9 0 0 1 21.8 10H14V2.2Z" opacity="0.5" /></>,
  // Đồng hồ đo — chỉ số hoạt động.
  'chi-so-hoat-dong': <><path d="M4 18a8 8 0 1 1 16 0" fill="none" strokeWidth="1.8" strokeLinecap="round" /><path d="M12 18l4.5-5" fill="none" strokeWidth="1.8" strokeLinecap="round" /><circle cx="12" cy="18" r="1.6" /></>,
  // Phễu — theo dõi quỹ rơi rụng qua từng bước.
  'quan-ly-goi-von': <><path d="M3.5 4h17l-6.5 8v7.5L10 21v-9L3.5 4Z" fill="none" strokeWidth="1.8" strokeLinejoin="round" /></>,
  // Kính lúp trên danh mục — thẩm định hồ sơ.
  'due-diligence': <><path d="M5 4h9l4 4v4" fill="none" strokeWidth="1.8" strokeLinejoin="round" /><path d="M5 4v16h5" fill="none" strokeWidth="1.8" strokeLinejoin="round" /><path d="M8 9h5M8 13h3" fill="none" strokeWidth="1.8" strokeLinecap="round" /><circle cx="16" cy="17" r="3.2" fill="none" strokeWidth="1.8" /><path d="M18.4 19.4 21 22" fill="none" strokeWidth="1.8" strokeLinecap="round" /></>,
};

export default function NhomMauIcon({ slug, size = 22 }) {
  const hinh = HINH[slug];
  if (!hinh) return null;
  return <svg className="nhom-mau-icon" viewBox="0 0 24 24" width={size} height={size}
    fill="currentColor" stroke="currentColor" aria-hidden="true" focusable="false">{hinh}</svg>;
}
